import { environment } from '@mortgage-pos/ui/env'
import { EncryptedSensitive } from '@mortgage-pos/types'
import { cheapUUID } from '@mortgage-pos/utils'
import http from './http'

export default class CryptoClient {
  static async encryptSensitiveData(payload: any): Promise<EncryptedSensitive> {
    try {
      const sensitiveUuid = cheapUUID()

      const encryptionResponse = await http.post(
        `${environment.apiBaseUrl}/api/encrypt-sensitive`,
        { payload, sensitiveUuid }
      )

      const encryptedPayload = encryptionResponse?.data as EncryptedSensitive

      return encryptedPayload
    } catch (error) {
      return null
    }
  }
}
